import React from 'react';
import { connect } from 'react-redux';

import InfosPiece from './InfosPiece';

class InfosPieceContainer extends React.Component {

    render() {

        const { infosLogistique, isLoading, piece, utilisateur } = this.props;

        return (
            <InfosPiece
                isLoading={isLoading}
                infosLogistique={infosLogistique}
                piece={piece}
                utilisateur={utilisateur}
            />
        );
    }
}

const mapStateToProps = state => ({
    infosLogistique: state.information.logistique.infosLogistique,
    isLoading: state.information.logistique.isInfosLogistiqueLoading,

    utilisateur: JSON.parse(localStorage.getItem('utilisateur'))
});

export default connect(mapStateToProps, null)(InfosPieceContainer);